import React, { useEffect, useState } from 'react'
import MobileHeader from '../../components/header/MobileHeader'
import LoginHeader from '../../components/header/LoginHeader'
import Footer from '../../components/footer'
import Gotop from '../../components/gotop'
// import RecommenJob from '../RecommenJob'
import Breadcrumb from "../../components/breadcrumb";
import RecommenJob from './RecommenJob'
import LoginMobileHeader from '../../components/header/LoginMobileHeader'


const RecommendationJobs = () => {
  const [isShowMobile, setShowMobile] = useState(false);

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  useEffect(() => {
    const WOW = require("wowjs");
    window.wow = new WOW.WOW({
      live: false,
    });
    window.wow.init();
  }, []);
  return (
    <>
      <LoginMobileHeader handleMobile={handleMobile} />

      <LoginHeader clname="act1" handleMobile={handleMobile} />
      {/* <Breadcrumb title="Recommendation Jobs" className="breadcrumb-section" /> */}

      {/* <RecommenJob /> */}
      {/* <Banner07 /> */}
      <RecommenJob />

      {/* <Footer /> */}
      <Gotop />
    </>
  )
}

export default RecommendationJobs